<template>
<div>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="dataTable"
    :items-per-page="itemPerPage"
    :page="tablePage"
    :footer-props="{'items-per-page-options': [5,10, 100]}"
    :search="search"
    :hide-default-header="true"
    :custom-filter="customFilter"
    no-results-text="查無符合資料"
    class="elevation-1"
  >
    <template v-slot:header="{props}">
      <thead class="v-data-table-header">
        <tr>
          <th
            v-for="(header, idx) in props.headers"
            :key="`header-${idx}-`+header.text"
            v-show="header.showInMobile || !isMobile"
          >
            <span>{{ header.text }}</span>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{pageTitle}}</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider>
        <span class="d-none d-sm-flex">權限: 主管以上</span> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="delaySearch"
          @input="onDelaySearchInput"
          append-icon="search"
          label="搜尋項目"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>

    <template v-slot:item="{item}">
      <todoItem-list-item
        :item="item"
        :key="`item-${item.ID}`"
        @done="done"
      />
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="reloadDataTable"
      >Reset</v-btn>
    </template>
  </v-data-table>


        <v-snackbar
          v-model="isDataRefetched"
          :timeout="-1"
        >
          偵測到資料已更新
          <v-btn
            class="ml-1 mr-1"
            color="pink"
            text
            @click="isDataRefetched = false"
          >
            關閉
          </v-btn>
          <v-btn
            class="ml-1 mr-1"
            color="white"
            text
            @click="reloadDataTable"
          >
            重新載入
          </v-btn>
        </v-snackbar>

</div>
</template>

<script>
import { mapGetters } from "vuex";
import TodoItemListItem from "./todoItem-list-item.vue";
import mixinDelaySearch from "@/ui/mixin-datatable-delaysearch.vue";
export default {
  mixins: [mixinDelaySearch],
  components: {
    TodoItemListItem
  },
  data: () => ({
    isLoading: false,
    // data table
    dataTable: [],
    pageTitle: "待辦事項",
    itemPerPage: 10, // -1 is all, default is 10, 5 is fine.
    tablePage: 1,
    search: "",
    // data refetched
    isDataRefetched: false
  }),
  computed: {
    headers() {
      return [
        { text: "日期", value: "-", showInMobile: true },
        { text: "專案", value: "-", showInMobile: true },
        { text: "項目", value: "-", showInMobile: true },
        { text: "執行人員", value: "-", showInMobile: true },
        { text: "完成時間", value: "-", showInMobile: true },
        { text: "操作", value: "action", showInMobile: true }
      ];
    },
    ...mapGetters(["myLevel", "todoItems", "me"])
  },
  methods: {
    customFilter(value, search, item) {
      return (
        item.Event.Content.includes(search) || item.Content.includes(search)
      );
    },
    done(id) {
      this.isLoading = true;
      this.$services.todoItem
        .done(this, id)
        .then(() => {
          let idx = this.todoItems.findIndex(o => o.ID == id);
          if (idx >= 0) {
            this.$set(this.todoItems[idx], "DoneAt", new Date());
            this.$set(this.todoItems[idx], "DoneBy", this.me.ID);
            this.reloadDataTable();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    reloadDataTable() {
      this.dataTable = this.todoItems.filter(o => o.IsActive);
      this.isDataRefetched = false;
      this.$store.state.todoItem.isReloaded = false;
      this.tablePage = 1
    }
  },
  created() {
    if (this.myLevel < 10) {
      alert("沒有權限");
      this.$router.push({ name: "main" });
      return;
    }
    this.isLoading = true;

    Promise.all([
      this.$services.prepareDatas(this),
      // this.$services.prepareProjectDatas(this) // 20220501 發現 prepareDatas時就會prepareProductDatas
    ]).finally(() => {
      this.$services.todoItem
        .prepareData(this)
        .then(this.reloadDataTable)
        .finally(() => {
          this.isLoading = false;
        });
    });
  },
  watch: {
    "$store.state.todoItem.isReloaded"() {
      if (
        this.$store.state.todoItem.isFetched &&
        this.$store.state.todoItem.isReloaded
      )
        this.isDataRefetched = true;
    }, search () {
      this.tablePage = 1
    }
  }
};
</script>